/* =========================================================
   Lavari Jewelers — Global Theme JS
   ========================================================= */
(function () {
  'use strict';

  /* -------------------------------------------------------
     Helpers
  ------------------------------------------------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  /* -------------------------------------------------------
     Sticky / solid header
  ------------------------------------------------------- */
  var header = qs('.site-header');
  if (header) {
    var isInnerPage = document.body.classList.contains('page-collection') || document.body.classList.contains('page-pdp') || document.body.classList.contains('page-list-collections');

    if (!isInnerPage) {
      /* Homepage only: transparent header becomes solid on scroll */
      var scrollThreshold = 80;
      function updateHeader() {
        if (window.scrollY > scrollThreshold) {
          header.classList.add('is-solid');
        } else {
          header.classList.remove('is-solid');
        }
      }
      window.addEventListener('scroll', updateHeader, { passive: true });
      updateHeader();
    }
    /* Inner pages: CSS handles sticky via the header-group wrapper — no JS needed */
  }

  /* -------------------------------------------------------
     Mobile drawer (hamburger menu)
  ------------------------------------------------------- */
  var mobileDrawer = qs('.mobile-drawer');
  if (mobileDrawer) {
    var mOverlay = qs('.overlay', mobileDrawer);
    var mClose = qs('.md-close', mobileDrawer);

    function openDrawer() {
      mobileDrawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      mobileDrawer.classList.remove('open');
      document.body.style.overflow = '';
      // Close all sub-panels
      qsa('.md-panel.open', mobileDrawer).forEach(function (p) { p.classList.remove('open'); });
    }

    qsa('.hamburger, .js-hamburger, #openDrawer').forEach(function (btn) { on(btn, 'click', openDrawer); });
    on(mClose, 'click', closeDrawer);
    on(mOverlay, 'click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileDrawer.classList.contains('open')) closeDrawer();
    });

    // Sub-panel navigation — buttons use data-panel="handle", panels use data-subpanel="handle"
    qsa('.md-link[data-panel]', mobileDrawer).forEach(function (btn) {
      on(btn, 'click', function () {
        var panelName = btn.dataset.panel;
        var panel = qs('[data-subpanel="' + panelName + '"]', mobileDrawer);
        if (panel) panel.classList.add('open');
      });
    });
    qsa('[data-back], .md-back', mobileDrawer).forEach(function (btn) {
      on(btn, 'click', function () {
        var panel = btn.closest('.md-panel');
        if (panel) panel.classList.remove('open');
      });
    });

    // data-close attribute (overlay + close button)
    qsa('[data-close]', mobileDrawer).forEach(function (el) {
      on(el, 'click', closeDrawer);
    });

    // Mobile accordion inside sub-panels — simple toggle, each item independent.
    // Items with children split their head into a link (navigates) and a
    // separate toggle button (expands/collapses); leaf items are a plain link
    // with no toggle button at all.
    qsa('.md-acc-head-toggle', mobileDrawer).forEach(function (btn) {
      on(btn, 'click', function () {
        var item = btn.closest('.md-acc-item');
        if (!item) return;
        item.classList.toggle('open');
      });
    });
  }

  /* -------------------------------------------------------
     Cart drawer
  ------------------------------------------------------- */
  var cartDrawer = qs('.cart-drawer');
  var cartOverlay = qs('.cart-drawer-overlay');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  qsa('.js-cart-open').forEach(function (btn) { on(btn, 'click', openCartDrawer); });
  on(cartOverlay, 'click', closeCartDrawer);
  on(qs('.js-cart-close'), 'click', closeCartDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) closeCartDrawer();
  });

  /* -------------------------------------------------------
     Cart count update
  ------------------------------------------------------- */
  function updateCartCount(count) {
    qsa('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.dataset.count = count;
      /* The header badge is rendered with an inline style="display:none" when
         the cart is empty on page load. That inline style outranks the
         .icon-badge[data-count="0"] rule, so the bubble could never come back
         after an AJAX add — drop it and let the stylesheet decide visibility
         from data-count. */
      el.style.removeProperty('display');
    });
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { updateCartCount(data.item_count || 0); })
      .catch(function () {});
  }
  fetchCartCount();

  /* -------------------------------------------------------
     Cart drawer line item render
  ------------------------------------------------------- */
  var CD_TRASH = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';

  function refreshCartDrawerFromSection() {
    if (!window.fetch || !window.DOMParser) return;
    fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var markup = data && data['cart-drawer'];
        if (!markup) return;
        var doc = new DOMParser().parseFromString(markup, 'text/html');
        var fresh = doc.querySelector('.cd-items');
        var body = qs('.cd-items');
        if (fresh && body) body.innerHTML = fresh.innerHTML;
        /* Per-code discount rows, subtotal and checkout amount come from the
           server too (exact cents, one row per code - see money-cart). */
        ['#cdDiscountRow', '#cdSubtotal', '.cd-checkout-amount'].forEach(function (sel) {
          var from = doc.querySelector(sel), to = qs(sel);
          if (from && to) { to.innerHTML = from.innerHTML; to.hidden = from.hidden; }
        });
      })
      .catch(function () {});
  }
  function renderCartDrawerItems(cart) {
    var body = qs('.cd-items');
    var foot = qs('.cd-foot');
    if (!body) return;

    /* "You may also like" is an empty-cart upsell only — hide it the moment
       the cart has anything in it, on every add/change/remove. */
    var recommend = qs('#cdRecommend');
    if (recommend) recommend.hidden = !!(cart.items && cart.items.length);

    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="cd-empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn-lav btn-solid js-cart-close">Continue Shopping</a></div>';
      if (foot) foot.hidden = true;
      updateShippingBar(0);
      return;
    }
    var html = '';
    cart.items.forEach(function (item, i) {
      var imgSrc = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_160x160$1$2') : '';
      var lineProps = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          if (!item.properties[k] || k.charAt(0) === '_') return;
          /* Matches cart-drawer.liquid / cart-line-item.liquid — client wants
             "Pre-Order" visible (not hidden) on both the drawer and
             checkout; just the key alone, not "Pre-Order: Yes" (the value is
             always the redundant literal "Yes"). Checkout itself always
             appends ": <value>" to any property it shows and that can't be
             suppressed from theme code (checkout is Shopify's own hosted
             page, not theme code) — this only controls our own drawer's
             markup. */
          if (k === 'Pre-Order') {
            lineProps += '<div class="cd-line-props">Pre-Order</div>';
            return;
          }
          lineProps += '<div class="cd-line-props">' + k + ': ' + item.properties[k] + '</div>';
        });
      }
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="cd-line-variant">' + item.variant_title + '</div>' : '';
      /* Per-unit price — the figure on the right is the line total (unit x qty) */
      var unitPrice = '<div class="cd-line-unit">' + formatMoney(item.final_price) + '</div>';
      var priceWas = item.original_line_price !== item.final_line_price
        ? '<s class="cd-line-was">' + formatMoney(item.original_line_price) + '</s>'
        : '';
      html += '<div class="cd-line" data-line="' + (i + 1) + '">'
        + '<a href="' + item.url + '" class="cd-line-img"><img src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy"></a>'
        + '<div class="cd-line-body">'
        + '<div class="cd-line-top">'
        + '<a href="' + item.url + '" class="cd-line-title">' + item.product_title + '</a>'
        + '<button class="cd-line-remove js-cd-remove" data-line="' + (i + 1) + '" aria-label="Remove">' + CD_TRASH + '</button>'
        + '</div>'
        + variant + unitPrice + lineProps
        + '<div class="cd-line-footer">'
        + '<div class="cd-qty-stepper">'
        + '<button class="cd-qty-btn js-cd-qty-down" data-line="' + (i + 1) + '" aria-label="Decrease quantity">−</button>'
        + '<input class="cd-qty-input" type="number" value="' + item.quantity + '" min="0" data-line="' + (i + 1) + '">'
        + '<button class="cd-qty-btn js-cd-qty-up" data-line="' + (i + 1) + '" aria-label="Increase quantity">+</button>'
        + '</div>'
        + '<div class="cd-line-price">' + priceWas + formatMoney(item.final_line_price) + '</div>'
        + '</div></div>'
        + '<span class="cd-line-spinner" aria-hidden="true"></span>'
        + '</div>';
    });
    body.innerHTML = html;
    if (foot) foot.hidden = false;
    /* The markup above is built from /cart.js, which carries no collection
       data - so the collection-sale prices and the applied-discount tags
       (both rendered in Liquid) would disappear after every add/qty change.
       Re-render the same section server-side and swap the lines in. */
    refreshCartDrawerFromSection();

    var subVal = qs('.cd-subtotal-val');
    if (subVal) subVal.textContent = formatMoney(cart.total_price);

    var discRow = qs('#cdDiscountRow');
    if (discRow) {
      var hasDiscount = cart.total_discount > 0;
      discRow.hidden = !hasDiscount;
      /* rows themselves are filled from the server render (refreshCartDrawerFromSection) */
    }

    var exclCents = cartSubtotalExcludingReturns(cart);
    var checkoutAmt = qs('.cd-checkout-amount');
    if (checkoutAmt) checkoutAmt.textContent = formatMoney(exclCents);

    var protectBtn = qs('.js-cd-checkout-protect');
    var protectAmt = qs('.cd-checkout-protect-amount');
    if (protectBtn && protectAmt) {
      var feeCents = parseInt(protectBtn.dataset.feeCents, 10) || 0;
      protectAmt.textContent = formatMoneyExact(exclCents + feeCents);
    }

    updateShippingBar(cart.total_price);
  }

  /* -------------------------------------------------------
     Checkout: "Free Returns" protection add-on (Redo)
  ------------------------------------------------------- */
  function isReturnProtectionItem(item) {
    return item.product_type === 'return' || item.vendor === 're:do';
  }
  /* Derived from total_price (already net of any cart-level discount) minus the
     protection line, so button amounts stay correct with a discount applied. */
  function cartSubtotalExcludingReturns(cart) {
    var returnsTotal = cart.items.reduce(function (sum, item) {
      return sum + (isReturnProtectionItem(item) ? item.final_line_price : 0);
    }, 0);
    return cart.total_price - returnsTotal;
  }
  function findReturnProtectionLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (isReturnProtectionItem(cart.items[i])) return i + 1;
    }
    return null;
  }
  function goToCheckoutWithoutProtection(btn) {
    btn.classList.add('is-loading');
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = findReturnProtectionLine(cart);
      if (!line) { window.location.href = '/checkout'; return; }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function () { window.location.href = '/checkout'; });
    }).catch(function () { window.location.href = '/checkout'; });
  }
  function goToCheckoutWithProtection(btn) {
    var variantId = parseInt(btn.dataset.variantId, 10);
    btn.classList.add('is-loading');
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (findReturnProtectionLine(cart)) { window.location.href = '/checkout'; return; }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function () { window.location.href = '/checkout'; });
    }).catch(function () { window.location.href = '/checkout'; });
  }

  /* Delegated cart-drawer controls (survive re-render) */
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var down = e.target.closest('.js-cd-qty-down');
      if (down) { cartDrawerChange(parseInt(down.dataset.line, 10), -1); return; }
      var up = e.target.closest('.js-cd-qty-up');
      if (up) { cartDrawerChange(parseInt(up.dataset.line, 10), 1); return; }
      var rm = e.target.closest('.js-cd-remove');
      if (rm) { cartDrawerSetQty(parseInt(rm.dataset.line, 10), 0); return; }
      var nt = e.target.closest('.js-cd-note-toggle');
      if (nt) {
        var wrap = nt.closest('.cd-note-wrap');
        var nbody = wrap.querySelector('.cd-note-body');
        var willOpen = nbody.hidden;
        nbody.hidden = !willOpen;
        wrap.classList.toggle('open', willOpen);
        nt.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }
      if (e.target.closest('.js-cart-close')) { closeCartDrawer(); return; }
      var addBtn = e.target.closest('.js-cd-recommend-add');
      if (addBtn) {
        if (addBtn.disabled) return;
        var variantId = parseInt(addBtn.dataset.variantId, 10);
        var origLabel = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        addToCart(variantId, 1, null).catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = origLabel;
        });
        return;
      }
    });
    cartDrawer.addEventListener('change', function (e) {
      var inp = e.target.closest('.cd-qty-input');
      if (inp) cartDrawerSetQty(parseInt(inp.dataset.line, 10), parseInt(inp.value, 10) || 0);
    });
  }

  /* Checkout buttons + Checkout+ info trigger are delegated from the document,
     not the drawer: the cart page renders the same controls but has no drawer. */
  document.addEventListener('click', function (e) {
    var co = e.target.closest('.js-cd-checkout');
    if (co) { e.preventDefault(); goToCheckoutWithoutProtection(co); return; }
    var cp = e.target.closest('.js-cd-checkout-protect');
    if (cp) { e.preventDefault(); goToCheckoutWithProtection(cp); return; }
    if (e.target.closest('.js-cd-protect-info')) { openProtectModal(); return; }
  });

  /* -------------------------------------------------------
     Checkout+ ("Free Returns") info modal
  ------------------------------------------------------- */
  var protectModal = qs('#cdProtectModal');
  function openProtectModal() {
    if (!protectModal) return;
    protectModal.classList.add('is-open');
    protectModal.setAttribute('aria-hidden', 'false');
  }
  function closeProtectModal() {
    if (!protectModal) return;
    protectModal.classList.remove('is-open');
    protectModal.setAttribute('aria-hidden', 'true');
  }
  if (protectModal) {
    protectModal.addEventListener('click', function (e) {
      if (e.target.closest('.js-cd-protect-modal-close')) closeProtectModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && protectModal.classList.contains('is-open')) closeProtectModal();
    });
  }

  /* -------------------------------------------------------
     Discount code (shared by the cart drawer and the cart page)

     POST /cart/update.js {discount: CODE} both applies the code and reports
     back whether it was accepted, via cart.discount_codes[].applicable — so an
     invalid code is surfaced inline and cleared instead of silently sticking
     to the cart and suppressing later valid codes.
  ------------------------------------------------------- */
  /* Also mirrors the code into a cart attribute: Liquid's cart.discount_codes
     is unreliable server-side (confirmed null there on a real cart with an
     active discount, even though cart.total_discount was correct) — so the
     snippet's server render reads this attribute instead. Setting it to ''
     alongside a rejected/removed code keeps it in sync automatically. */
  /* Multiple codes (client handover, 16 Oct 2026): Shopify applies several
     codes when /cart/update.js gets them comma-separated ("A,B"), as long as
     they are set to combine in Admin. The theme used to send only the code
     just typed (overwriting the others), show only the first applicable one,
     and clear everything when a code was rejected. Now the full list of
     working codes is always sent, every one gets its own tag, and a rejected
     code puts back the ones that were working. The list is also mirrored
     into the applied_discount_code cart attribute (comma-separated) for the
     server render - Liquid's cart.discount_codes is unreliable here. */
  function setDiscount(codes) {
    var list = (Array.isArray(codes) ? codes : [codes]).filter(Boolean);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: list.join(','), attributes: { applied_discount_code: list.join(',') } })
    }).then(function (r) { return r.json(); });
  }

  function activeCodes(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
  }

  /* The cart page re-renders its whole box from the server after a discount
     change, which wiped the "applied" / "can't be combined" message. The
     last message is kept once and put back by lavRestoreDiscountMsg(),
     which main-cart.liquid calls right after its re-render. */
  var pendingDiscountMsg = null;
  function paintDiscountMsg(scope, text, isError) {
    var msg = qs('.js-discount-msg', scope);
    if (!msg) return;
    msg.textContent = text;
    msg.classList.toggle('is-error', !!isError);
    msg.classList.toggle('is-success', !isError);
    msg.hidden = !text;
  }
  function discountMsg(scope, text, isError) {
    pendingDiscountMsg = text ? { text: text, isError: !!isError } : null;
    paintDiscountMsg(scope, text, isError);
  }
  window.lavRestoreDiscountMsg = function () {
    if (!pendingDiscountMsg) return;
    var m = pendingDiscountMsg;
    pendingDiscountMsg = null;
    qsa('#cartpRoot .cart-discount').forEach(function (scope) { paintDiscountMsg(scope, m.text, m.isError); });
  };

  /* One navy chip per code, each with its own remove button (data-code). */
  function renderAppliedDiscount(scope, codes) {
    var applied = qs('.js-discount-applied', scope);
    var input = qs('.js-discount-input', scope);
    codes = codes || [];
    if (applied) {
      applied.innerHTML = '';
      codes.forEach(function (code) {
        var chip = document.createElement('span');
        chip.className = 'cart-discount-chip';
        var tag = document.createElement('span');
        tag.className = 'cart-discount-tag js-discount-tag';
        tag.textContent = code;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cart-discount-remove js-discount-remove';
        btn.setAttribute('aria-label', 'Remove discount ' + code);
        btn.dataset.code = code;
        btn.innerHTML = '&times;';
        chip.appendChild(tag);
        chip.appendChild(btn);
        applied.appendChild(chip);
      });
      applied.hidden = !codes.length;
    }
    if (input && codes.length) input.value = '';
    /* A live-applied discount should always leave the accordion open, same
       as the server-rendered state on a fresh page load. */
    if (codes.length) {
      var body = qs('.cart-discount-body', scope);
      var toggle = qs('.js-discount-toggle', scope);
      if (body) body.hidden = false;
      scope.classList.add('open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
  }

  /* Re-sync every discount UI on the page, then let the cart surfaces redraw. */
  function afterDiscountChange() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var codes = activeCodes(cart);
      qsa('.cart-discount').forEach(function (scope) { renderAppliedDiscount(scope, codes); });
      if (cartDrawer) renderCartDrawerItems(cart);
      updateCartCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:discount-changed'));
      return cart;
    });
  }

  function applyDiscount(scope, btn) {
    var input = qs('.js-discount-input', scope);
    var code = input ? input.value.trim() : '';
    if (!code) { discountMsg(scope, 'Enter a discount code.', true); return; }
    btn.disabled = true;
    discountMsg(scope, '');
    var current = [];
    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (cart) {
        current = activeCodes(cart);
        if (current.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
          discountMsg(scope, 'This code is already applied.', true);
          return null;
        }
        return setDiscount(current.concat(code));
      })
      .then(function (cart) {
        if (!cart) return;
        var entry = (cart.discount_codes || []).filter(function (d) {
          return d.code.toLowerCase() === code.toLowerCase();
        })[0];
        if (entry && entry.applicable) {
          discountMsg(scope, 'Discount applied.', false);
          return afterDiscountChange();
        }
        /* Rejected: put back the codes that were working, not an empty list. */
        return setDiscount(current).then(function () {
          discountMsg(scope, current.length
            ? 'This code can\u2019t be combined with the discount already applied, or isn\u2019t valid for this cart.'
            : 'That discount code isn\u2019t valid for this cart.', true);
          return afterDiscountChange();
        });
      })
      .catch(function () { discountMsg(scope, 'Something went wrong. Please try again.', true); })
      .finally(function () { btn.disabled = false; });
  }

  function removeDiscount(scope, btn) {
    var code = btn && btn.dataset ? btn.dataset.code : '';
    btn.disabled = true;
    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (cart) {
        var keep = code ? activeCodes(cart).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }) : [];
        return setDiscount(keep);
      })
      .then(function () {
        discountMsg(scope, '');
        return afterDiscountChange();
      })
      .catch(function () { discountMsg(scope, 'Something went wrong. Please try again.', true); })
      .finally(function () { btn.disabled = false; });
  }

  /* Page load: the server render comes from the saved attribute, which can
     list a code that has since stopped applying (cart changed). Re-draw the
     tags from Shopify's live list - tags only, no cart redraw. */
  if (qs('.js-discount-applied')) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var codes = activeCodes(cart);
      qsa('.cart-discount').forEach(function (scope) { renderAppliedDiscount(scope, codes); });
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.js-discount-toggle');
    if (toggle) {
      var wrap = toggle.closest('.cart-discount');
      var body = qs('.cart-discount-body', wrap);
      var willOpen = body.hidden;
      body.hidden = !willOpen;
      wrap.classList.toggle('open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) {
        var inp = qs('.js-discount-input', wrap);
        if (inp) inp.focus();
      }
      return;
    }
    var applyBtn = e.target.closest('.js-discount-apply');
    if (applyBtn) { applyDiscount(applyBtn.closest('.cart-discount'), applyBtn); return; }
    var removeBtn = e.target.closest('.js-discount-remove');
    if (removeBtn) { removeDiscount(removeBtn.closest('.cart-discount'), removeBtn); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('.js-discount-input');
    if (!input) return;
    e.preventDefault();
    var applyBtn = qs('.js-discount-apply', input.closest('.cart-discount'));
    if (applyBtn) applyBtn.click();
  });

  function cartDrawerChange(line, delta) {
    var input = qs('.cd-qty-input[data-line="' + line + '"]');
    var currentQty = input ? parseInt(input.value, 10) : 1;
    cartDrawerSetQty(line, Math.max(0, currentQty + delta));
  }

  /* Shopify's cart endpoints answer a rejected change with HTTP 422 and a body
     of {status, message, description} — no line items and no item_count. fetch
     does not reject on 422, so that payload used to be passed straight to
     renderCartDrawerItems(), which read the missing .items as "empty" and blanked
     the drawer (and the header count) even though the cart still had its
     contents. Always screen for an error payload before rendering anything. */
  function cartErrorMessage(res) {
    if (!res || !res.status) return null;
    return res.description || res.message || 'Sorry, we could not update your cart.';
  }
  function clearCartErrors(scope) {
    (scope || document).querySelectorAll('.cart-error-msg').forEach(function (el) { el.remove(); });
  }
  function showCartDrawerError(line, msg) {
    var lineEl = qs('.cd-line[data-line="' + line + '"]');
    var el = document.createElement('div');
    el.className = 'cart-error-msg';
    el.setAttribute('role', 'alert');
    el.textContent = msg;
    var host = lineEl && lineEl.querySelector('.cd-line-body');
    if (host) { host.appendChild(el); return; }
    var body = qs('.cd-items');
    if (body) body.insertBefore(el, body.firstChild);
  }

  function cartDrawerSetQty(line, qty) {
    var lineEl = qs('.cd-line[data-line="' + line + '"]');
    if (lineEl) lineEl.classList.add('is-updating');
    clearCartErrors(cartDrawer);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      var err = cartErrorMessage(res);
      if (!err) {
        renderCartDrawerItems(res);
        updateCartCount(res.item_count);
        return;
      }
      /* Error payload carries no items — re-read the real cart so the drawer
         keeps showing the true contents, then report what went wrong. */
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        renderCartDrawerItems(cart);
        updateCartCount(cart.item_count);
        showCartDrawerError(line, err);
      });
    })
    .catch(function () { if (lineEl) lineEl.classList.remove('is-updating'); });
  }

  /* Two-step bar - mirrors cart-drawer.liquid. The amounts are read from
     .cd-shipping-bar; this used to read them from .cd-ship-fill, which has
     no data attributes, so every Ajax update fell back to a $150 goal. */
  function updateShippingBar(totalPrice) {
    var wrap = qs('.cd-shipping-bar');
    var bar = qs('.cd-ship-fill');
    var text = qs('.cd-ship-text');
    if (!wrap || !bar) return;
    /* Shipping promotion on: the bar shows the promo message, full - leave it. */
    if (wrap.dataset.promo) return;
    var second = parseInt(wrap.dataset.threshold || '25000', 10);
    var first = parseInt(wrap.dataset.first || '0', 10);
    var goal = (first > 0 && totalPrice < first) ? first : second;
    bar.style.width = Math.min(100, Math.round(totalPrice / goal * 100)) + '%';
    if (!text) return;
    var tick = '<span class="cd-ship-ico" aria-hidden="true">✓</span> ';
    if (totalPrice >= second) {
      text.innerHTML = tick + "You've unlocked <strong>free 2-day shipping!</strong>";
    } else if (first > 0 && totalPrice < first) {
      text.innerHTML = "You're <strong>" + formatMoney(first - totalPrice) + '</strong> away from <strong>free shipping</strong>';
    } else {
      text.innerHTML = (first > 0 ? tick + 'Free shipping unlocked. ' : '')
        + "You're <strong>" + formatMoney(second - totalPrice) + '</strong> away from <strong>free 2-day shipping</strong>';
    }
  }

  /* -------------------------------------------------------
     Add to cart (Ajax)
  ------------------------------------------------------- */
  /* Turns an /cart/add.js error payload (HTTP 422, which fetch resolves rather
     than rejects) into a real rejection, so every caller's .catch() runs and
     can surface the reason instead of silently reporting success. */
  function throwIfCartError(res) {
    var err = cartErrorMessage(res);
    if (err) {
      var e = new Error(err);
      e.cartMessage = err;
      throw e;
    }
    return res;
  }
  function postCartAddTail() {
    return fetch('/cart.js').then(function (r) { return r.json(); })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      renderCartDrawerItems(cart);
      openCartDrawer();
      return cart;
    });
  }
  function addToCart(variantId, qty, properties) {
    qty = qty || 1;
    var body = { id: variantId, quantity: qty };
    if (properties) body.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function (r) { return r.json(); })
    .then(throwIfCartError)
    .then(postCartAddTail);
  }
  /* Atomic multi-item add — used by bundle/"frequently purchased together"
     widgets so all checked items land in the cart with a single request
     instead of N sequential single-item adds. */
  function addMultiple(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { return r.json(); })
    .then(throwIfCartError)
    .then(postCartAddTail);
  }
  /* Exposed for callers (main-product's own AJAX submit handler, etc.) that
     already made their own successful /cart/add.js request and just need
     the count/drawer refreshed — avoids re-POSTing to cart/add.js again. */
  window.LavariCart = { add: addToCart, addMultiple: addMultiple, refreshDrawer: postCartAddTail };

  /* -------------------------------------------------------
     Product card — variant swatches, price, image, AJAX ATC
     (delegated so AJAX-loaded / filtered cards keep working)
  ------------------------------------------------------- */
  function cardVariants(card) {
    var el = card.querySelector('.pcard-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }
  function cardSelectedOptions(card) {
    var opts = [];
    card.querySelectorAll('.pcard-sw-group').forEach(function (g) {
      var active = g.querySelector('.pcard-sw.active') || g.querySelector('.pcard-sw');
      opts[parseInt(g.dataset.optionIndex, 10)] = active ? active.dataset.value : null;
    });
    return opts;
  }
  function cardFindVariant(card, opts) {
    return cardVariants(card).filter(function (v) {
      return v.options.every(function (o, i) { return String(o) === String(opts[i]); });
    })[0];
  }
  function markCardSwatches(card, opts) {
    card.querySelectorAll('.pcard-sw').forEach(function (sw) {
      var idx = parseInt(sw.dataset.optionIndex, 10);
      var test = opts.slice();
      test[idx] = sw.dataset.value;
      var found = cardFindVariant(card, test);
      var unavail = !found || !found.available;
      sw.classList.toggle('pcard-sw--unavailable', unavail);
    });
  }
  /* Sitewide fixed-sale fallback (mirrors product-card.liquid / main-product.liquid):
     a real compare_at always wins (struck = compare_at, big price = the real
     variant.price). Otherwise, if the merchant's sitewide sale toggle is on,
     treat variant.price itself AS the MSRP (struck through, unchanged) and
     compute a lower display price = price x (1 - fixed%) as the big sale
     price — display only, doesn't change what's actually added to cart. */
  function fixedSaleSettings() {
    var el = document.getElementById('themeFixedSale');
    return {
      enabled: !!(el && el.getAttribute('data-enabled') === 'true'),
      percent: el ? parseFloat(el.getAttribute('data-percent')) : 0
    };
  }
  function cardPriceDisplay(variant, card) {
    if (variant.compare_at && variant.compare_at > variant.price) {
      return { compareAt: variant.compare_at, displayPrice: variant.price, note: '' };
    }
    /* Collection sale (Theme settings > Collection Sale / collection
       metafields), rendered server-side onto the card. It beats the sitewide
       sale, the same order main-product.liquid and product-card.liquid use. */
    var colPct = card && card.dataset ? parseInt(card.dataset.colsalePct, 10) : NaN;
    if (colPct > 0 && colPct < 100) {
      var colDiscount = Math.floor(variant.price * (colPct / 100));
      return {
        compareAt: variant.price,
        displayPrice: variant.price - colDiscount,
        note: (card.dataset.colsaleNote || '')
      };
    }
    /* Price-threshold sale (snippets/price-sale.liquid): applies only when
       THIS variant's price meets the minimum, so switching to a cheaper
       variant on the card drops it. */
    var ds = card && card.dataset ? card.dataset : {};
    var thMin = parseInt(ds.thsaleMin, 10);
    if (!isNaN(thMin) && variant.price >= thMin) {
      var thAmount = parseInt(ds.thsaleAmount, 10) || 0;
      var thPct = parseInt(ds.thsalePct, 10) || 0;
      var thOff = thAmount > 0 ? thAmount : Math.floor(variant.price * (thPct / 100));
      if (thOff > 0 && thOff < variant.price) {
        return { compareAt: variant.price, displayPrice: variant.price - thOff, note: (ds.thsaleNote || '') };
      }
    }
    var fs = fixedSaleSettings();
    if (fs.enabled && fs.percent > 0 && fs.percent < 100) {
      /* floor (not round) matches Shopify's own real "LABOR DAY SALE |
         10% Off" automatic discount, confirmed live to floor the discount
         to the cent rather than round it. */
      var discount = Math.floor(variant.price * (fs.percent / 100));
      return { compareAt: variant.price, displayPrice: variant.price - discount, note: '' };
    }
    return { compareAt: 0, displayPrice: variant.price, note: '' };
  }
  function updateCard(card, variant) {
    var priceEl = card.querySelector('.pcard-price');
    var atc = card.querySelector('.js-card-atc');
    var img = card.querySelector('.pcard-img--primary') || card.querySelector('.pcard-img');
    var secondaryImg = card.querySelector('.pcard-img--secondary');
    var label = atc && atc.querySelector('.pcard-atc-label');
    if (variant) {
      if (priceEl) {
        var pd = cardPriceDisplay(variant, card);
        var noteHtml = pd.note ? ' <span class="pcard-sale-code">' + pd.note + '</span>' : '';
        /* The star rating lives inside .pcard-price too - keep it, the
           rebuild below used to wipe it on every swatch click. */
        var rating = Array.prototype.slice.call(priceEl.querySelectorAll('.pcard-rating-divider, .pcard-stars'));
        priceEl.innerHTML = pd.compareAt
          ? '<s class="pcard-compare-price">' + formatMoney(pd.compareAt) + '</s> <span class="pcard-sale-price">' + formatMoney(pd.displayPrice) + '</span>' + noteHtml
          : formatMoney(pd.displayPrice) + noteHtml;
        rating.forEach(function (el) { priceEl.appendChild(document.createTextNode(' ')); priceEl.appendChild(el); });
      }
      /* "1 LEFT" badge follows the selected variant (fewer than 2 in stock).
         The card's variant JSON is built in Liquid, so inventory_quantity is
         present here - unlike product.variants | json on the PDP. */
      var leftBadge = card.querySelector('.js-pcard-left');
      if (leftBadge) {
        var leftQty = variant.inventory_quantity;
        var showLeft = variant.inventory_management === 'shopify' && leftQty > 0 && leftQty < 2;
        leftBadge.hidden = !showLeft;
        var leftNum = leftBadge.querySelector('.js-pcard-left-num');
        if (showLeft && leftNum) leftNum.textContent = leftQty;
      }
      if (variant.img) {
        /* Both <img> tags carry a server-rendered srcset (for responsive
           sizing) — browsers resolve srcset ahead of the plain src attribute,
           so just setting .src silently no-ops visually (currentSrc stays on
           the old srcset candidate) even though .src itself is correct. Drop
           srcset/sizes so the swapped src actually renders. */
        if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = variant.img; }
        /* Keep the hover (second) image in sync with the selected variant —
           img2 is the variant's own second Rubik-assigned photo when it has
           one, else it's already been set equal to img server-side — either
           way this never shows another variant's stale/mismatched photo. */
        if (secondaryImg) { secondaryImg.removeAttribute('srcset'); secondaryImg.removeAttribute('sizes'); secondaryImg.src = variant.img2 || variant.img; }
      }
      if (atc) {
        /* Pre-order: mirrors main-product.liquid — "Continue selling when out
           of stock" on (is_preorder in the card's variant JSON comes from
           inventory_policy), whatever the stock level. */
        var preorder = !!(variant.available && variant.is_preorder === true);
        atc.dataset.variantId = variant.id;
        atc.disabled = !variant.available;
        atc.classList.toggle('pcard-atc--disabled', !variant.available);
        atc.classList.toggle('pcard-atc--preorder', preorder);
        if (preorder) {
          atc.dataset.preorderEta = variant.preorder_eta || 'up to 4 weeks';
        } else {
          delete atc.dataset.preorderEta;
        }
        if (label) label.textContent = preorder ? 'Pre-Order' : (variant.available ? '+ Add to Cart' : 'Sold Out');
      }
    } else if (atc) {
      atc.disabled = true;
      atc.classList.add('pcard-atc--disabled');
      if (label) label.textContent = 'Unavailable';
    }
    markCardSwatches(card, cardSelectedOptions(card));
  }

  document.addEventListener('click', function (e) {
    /* Swatch select */
    var sw = e.target.closest('.pcard-sw');
    if (sw && !sw.disabled) {
      var card = sw.closest('.pcard');
      var group = sw.closest('.pcard-sw-group');
      if (group) {
        group.querySelectorAll('.pcard-sw').forEach(function (b) {
          var on = b === sw;
          b.classList.toggle('active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var gv = group.querySelector('.pcard-sw-groupval');
        if (gv) gv.textContent = sw.dataset.value;
      }
      updateCard(card, cardFindVariant(card, cardSelectedOptions(card)));
      return;
    }
    /* Add to cart (spinner + open drawer) */
    var atc = e.target.closest('.js-card-atc');
    if (atc && !atc.disabled) {
      e.preventDefault();
      var variantId = atc.dataset.variantId;
      if (!variantId) return;
      atc.classList.add('is-loading');
      var preorderEta = atc.dataset.preorderEta;
      var properties = preorderEta ? { 'Pre-Order': 'Yes', 'Estimated Delivery': preorderEta } : null;
      addToCart(variantId, 1, properties).then(function () {
        atc.classList.remove('is-loading');
      }).catch(function () {
        atc.classList.remove('is-loading');
      });
    }
  });

  /* Mark initially-unavailable swatches on load. Deliberately NOT calling
     updateCard() here — the server-rendered primary/secondary <img> (the
     product's own featured_media/media[1] hover shot) should keep showing
     as-is until the shopper actually picks a variant; updateCard() only
     takes over the hover image (see img2 in updateCard) once a swatch
     click tells us which variant they want. */
  qsa('.pcard').forEach(function (card) {
    if (card.querySelector('.pcard-data')) markCardSwatches(card, cardSelectedOptions(card));
  });

  /* -------------------------------------------------------
     Wishlist (localStorage, works across the whole theme)
  ------------------------------------------------------- */
  var WISHLIST_KEY = 'lavari_wishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; } }
  function wlSet(arr) { try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr)); } catch (e) {} wlUpdateCount(); }
  function wlHas(id) { return wlGet().some(function (x) { return String(x.id) === String(id); }); }
  function wlToggle(item) {
    var arr = wlGet();
    var i = -1;
    arr.forEach(function (x, idx) { if (String(x.id) === String(item.id)) i = idx; });
    if (i > -1) { arr.splice(i, 1); } else { arr.push(item); }
    wlSet(arr);
    return i === -1;
  }
  function wlUpdateCount() {
    var c = wlGet().length;
    qsa('.js-wishlist-count').forEach(function (el) { el.textContent = c; el.style.display = c > 0 ? '' : 'none'; });
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: wlGet() } }));
  }
  function wlMarkButtons() {
    qsa('.js-wishlist-btn').forEach(function (btn) { btn.classList.toggle('is-active', wlHas(btn.dataset.productId)); });
  }
  function wlItemFromBtn(btn) {
    var item = {
      id: btn.dataset.productId,
      handle: btn.dataset.productHandle || '',
      variantId: btn.dataset.productVariantId || '',
      hasOnlyDefaultVariant: btn.dataset.productHasOnlyDefaultVariant === 'true'
    };
    var card = btn.closest('.pcard');
    if (card) {
      var nameEl = card.querySelector('.pcard-name');
      var imgEl = card.querySelector('.pcard-img');
      var priceEl = card.querySelector('.pcard-price');
      item.title = nameEl ? nameEl.textContent.trim() : (btn.dataset.productTitle || '');
      item.url = nameEl ? nameEl.getAttribute('href') : (card.dataset.url || '');
      item.image = imgEl ? imgEl.getAttribute('src') : '';
      item.price = priceEl ? priceEl.textContent.trim() : '';
    } else {
      item.title = btn.dataset.productTitle || '';
      item.url = btn.dataset.productUrl || (item.handle ? '/products/' + item.handle : '');
      item.image = btn.dataset.productImage || '';
      item.price = btn.dataset.productPrice || '';
    }
    return item;
  }
  document.addEventListener('click', function (e) {
    var wb = e.target.closest('.js-wishlist-btn');
    if (!wb) return;
    e.preventDefault();
    var added = wlToggle(wlItemFromBtn(wb));
    wb.classList.toggle('is-active', added);
    wb.setAttribute('aria-pressed', added ? 'true' : 'false');
  });
  // expose for the wishlist page
  window.LavariWishlist = { get: wlGet, remove: function (id) { var a = wlGet().filter(function (x) { return String(x.id) !== String(id); }); wlSet(a); }, mark: wlMarkButtons };
  wlUpdateCount();
  wlMarkButtons();

  /* -------------------------------------------------------
     Cart note save (debounced)
  ------------------------------------------------------- */
  var cdNote = qs('.js-cart-note');
  if (cdNote) {
    var noteTimer;
    on(cdNote, 'input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: cdNote.value })
        }).catch(function () {});
      }, 600);
    });
  }

  /* -------------------------------------------------------
     Brand feature strip -> slider on mobile
  ------------------------------------------------------- */
  qsa('.js-bf-grid').forEach(function (bfGrid) {
    var bfSwiper = null;
    function setupBrandFeatures() {
      var isMobile = window.matchMedia('(max-width: 991.98px)').matches;
      if (isMobile && !bfSwiper && window.Swiper) {
        bfGrid.classList.add('swiper-wrapper');
        var wrap = document.createElement('div');
        wrap.className = 'swiper brand-features-swiper';
        bfGrid.parentNode.insertBefore(wrap, bfGrid);
        wrap.appendChild(bfGrid);
        Array.prototype.forEach.call(bfGrid.children, function (c) { c.classList.add('swiper-slide'); });
        var pg = document.createElement('div');
        pg.className = 'swiper-pagination';
        wrap.appendChild(pg);
        bfSwiper = new Swiper(wrap, {
          slidesPerView: 1, spaceBetween: 16,
          loop: true,
          pagination: { el: pg, clickable: true },
          autoplay: { delay: 5000, disableOnInteraction: false }
        });
        var maxH = 0;
        Array.prototype.forEach.call(bfGrid.children, function (c) { c.style.height = 'auto'; });
        Array.prototype.forEach.call(bfGrid.children, function (c) { maxH = Math.max(maxH, c.offsetHeight); });
        Array.prototype.forEach.call(bfGrid.children, function (c) { c.style.height = maxH + 'px'; });
      } else if (!isMobile && bfSwiper) {
        bfSwiper.destroy(true, true);
        bfSwiper = null;
        var existingWrap = bfGrid.closest('.brand-features-swiper');
        bfGrid.classList.remove('swiper-wrapper');
        Array.prototype.forEach.call(bfGrid.children, function (c) { c.classList.remove('swiper-slide'); c.style.height = ''; });
        existingWrap.parentNode.insertBefore(bfGrid, existingWrap);
        existingWrap.remove();
      }
    }
    setupBrandFeatures();
    var bfResizeTimer;
    window.addEventListener('resize', function () { clearTimeout(bfResizeTimer); bfResizeTimer = setTimeout(setupBrandFeatures, 200); });
  });

  /* -------------------------------------------------------
     PDP Gallery
  ------------------------------------------------------- */
  (function () {
    var mainMedia = qs('#pdpMainMedia');
    if (!mainMedia) return; // not a PDP page

    var thumbsSwiper  = qs('#pdpThumbsSwiper');
    var mobileSwiper  = qs('#pdpMobileSwiper');
    var thumbPrev     = qs('.pdp-thumb-prev');
    var thumbNext     = qs('.pdp-thumb-next');

    /* --- Activate a thumbnail and sync main image --- */
    function activateThumb(thumbEl) {
      if (!thumbEl) return;
      var mediaId = thumbEl.dataset.mediaId;
      var idx     = parseInt(thumbEl.dataset.index || '0', 10);
      qsa('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumbEl.classList.add('active');
      qsa('.pdp-media-item', mainMedia).forEach(function (item) {
        item.classList.toggle('active', item.dataset.mediaId === mediaId);
      });
      if (window._pdpMobileSwiper) window._pdpMobileSwiper.slideTo(idx);
    }

    /* Bind clicks on thumbs — works before or after Swiper wraps them */
    qsa('.pdp-thumb').forEach(function (thumb) {
      on(thumb, 'click', function () { activateThumb(thumb); });
    });

    /* --- Desktop thumbnail Swiper (prev/next arrows) --- */
    if (thumbsSwiper && window.Swiper) {
      window._pdpThumbSwiper = new Swiper(thumbsSwiper, {
        slidesPerView: 4,
        spaceBetween: 14,
        watchOverflow: true,
        navigation: {
          prevEl: thumbPrev,
          nextEl: thumbNext,
          disabledClass: 'swiper-button-disabled'
        }
      });
    }

    /* --- Mobile main-image Swiper (dots pagination) ---
         Only init when actually visible (≤991px). */
    function initMobileSwiper() {
      if (window._pdpMobileSwiper || !mobileSwiper || !window.Swiper) return;
      if (window.innerWidth > 991) return;
      /* Starts on the currently-selected variant's image (set server-side
         via data-initial-index), not always slide 0 — Swiper otherwise
         always opens on the first product image regardless of variant. */
      var initialIndex = parseInt(mobileSwiper.dataset.initialIndex || '0', 10) || 0;
      window._pdpMobileSwiper = new Swiper(mobileSwiper, {
        slidesPerView: 1,
        spaceBetween: 0,
        initialSlide: initialIndex,
        pagination: { el: '.pdp-mobile-dots', clickable: true },
        on: {
          slideChange: function (sw) {
            var thumbs = qsa('.pdp-thumb');
            if (thumbs[sw.activeIndex]) activateThumb(thumbs[sw.activeIndex]);
          }
        }
      });
    }

    initMobileSwiper();
    window.addEventListener('resize', function () {
      if (window.innerWidth <= 991) initMobileSwiper();
    });

  }());

  /* -------------------------------------------------------
     Money formatter — mirrors the store's Settings > General
     currency formatting (shop.money_format), same technique
     used on the product page, so JS-rendered prices (product
     card swatches, cart drawer) always match server-rendered ones.
  ------------------------------------------------------- */
  /* Inserts a separator every 3 digits into a whole-number string,
     e.g. withCommas("20038", ",") -> "20,038" */
  function withCommas(numStr, sep) {
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function formatMoney(cents) {
    var amount = cents / 100;
    var fmtEl = document.getElementById('themeMoneyFormat');
    var fmt = (fmtEl && fmtEl.getAttribute('data-fmt')) || '${{amount}}';
    /* Longer/more-specific patterns replaced first to avoid partial matches.
       Every branch always adds thousands separators — this store's configured
       money_format (amount_no_decimals) omits them, so they're applied here
       regardless of which placeholder matched. */
    fmt = fmt.replace(/\{\{amount_no_decimals_with_comma_separator\}\}/g,
      withCommas(Math.round(amount).toString(), ','));
    fmt = fmt.replace(/\{\{amount_with_comma_separator\}\}/g, function () {
      /* European-style: '.' for thousands, ',' for the decimal point */
      var parts = amount.toFixed(2).split('.');
      return withCommas(parts[0], '.') + ',' + parts[1];
    });
    fmt = fmt.replace(/\{\{amount_no_decimals\}\}/g,
      withCommas(Math.round(amount).toString(), ','));
    fmt = fmt.replace(/\{\{amount\}\}/g, function () {
      var parts = amount.toFixed(2).split('.');
      return withCommas(parts[0], ',') + '.' + parts[1];
    });
    return fmt;
  }

  /* Always 2-decimal with thousands separators, ignores shop.money_format —
     used where a fractional-cent fee (e.g. Free Returns add-on) would
     otherwise get rounded away. */
  function formatMoneyExact(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    return '$' + withCommas(parts[0], ',') + '.' + parts[1];
  }

  /* -------------------------------------------------------
     Category tabs scroll indicator (.col-tabs)
     Native scrollbars are unreliable on touch devices, so this
     always-visible custom thumb tracks horizontal scroll position.
  ------------------------------------------------------- */
  (function () {
    var track = document.getElementById('colTabsScrollbar');
    var thumb = document.getElementById('colTabsScrollbarThumb');
    var tabs = qs('.col-tabs');
    if (!track || !thumb || !tabs) return;

    function update() {
      var scrollable = tabs.scrollWidth - tabs.clientWidth;
      if (scrollable <= 1) {
        track.classList.remove('is-visible');
        return;
      }
      track.classList.add('is-visible');
      var thumbWidthPct = Math.max(10, (tabs.clientWidth / tabs.scrollWidth) * 100);
      var trackWidth = track.clientWidth;
      var thumbWidthPx = (thumbWidthPct / 100) * trackWidth;
      var maxThumbTravel = trackWidth - thumbWidthPx;
      var scrollRatio = tabs.scrollLeft / scrollable;
      var thumbX = scrollRatio * maxThumbTravel;
      thumb.style.width = thumbWidthPct + '%';
      thumb.style.transform = 'translateX(' + thumbX + 'px)';
    }

    tabs.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* Desktop has no touch/swipe gesture and the custom thumb replaced the
       native (draggable) scrollbar, so give mouse users two ways to scroll
       horizontally: wheel-over-row, and click-and-drag the row itself. */
    tabs.addEventListener('wheel', function (e) {
      var scrollable = tabs.scrollWidth - tabs.clientWidth;
      if (scrollable <= 1) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      tabs.scrollLeft += e.deltaY;
      e.preventDefault();
    }, { passive: false });

    var dragging = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    tabs.addEventListener('mousedown', function (e) {
      var scrollable = tabs.scrollWidth - tabs.clientWidth;
      if (scrollable <= 1) return;
      dragging = true;
      dragMoved = false;
      tabs.classList.add('is-dragging');
      dragStartX = e.pageX;
      dragStartScroll = tabs.scrollLeft;
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      var dx = e.pageX - dragStartX;
      if (Math.abs(dx) > 3) dragMoved = true;
      tabs.scrollLeft = dragStartScroll - dx;
    });
    window.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      tabs.classList.remove('is-dragging');
    });
    /* Suppress the click-through navigation only when the mousedown actually
       turned into a drag, so a normal tap on a tab still works. */
    tabs.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true);
  })();

  /* -------------------------------------------------------
     Initial cart drawer load (if open on page load)
  ------------------------------------------------------- */
  if (cartDrawer && cartDrawer.classList.contains('is-open')) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawerItems).catch(function () {});
  }

})();
